export default __webpack_public_path__ + "static/media/ipad_large.b22c2b9f.png";